import type { ClientOptions } from 'ably';

/**
 * Ably connection hosts, routed through Natter's own CNAMEs (each points at Ably) so client
 * network teams can whitelist `*.natter.co` rather than Ably's domains. Hardcoded rather than
 * env-driven so every environment uses the same hosts we document for onboarding.
 *
 * An FQDN `endpoint` serves both realtime and REST (token exchange) traffic, and disables Ably's
 * default fallbacks — so `fallbackHosts` must be listed explicitly.
 */
export const ABLY_HOST_OPTIONS = {
  endpoint: 'realtime.natter.co',
  fallbackHosts: [
    'a.fallback.natter.co',
    'b.fallback.natter.co',
    'c.fallback.natter.co',
    'd.fallback.natter.co',
    'e.fallback.natter.co',
  ],
} satisfies Pick<ClientOptions, 'endpoint' | 'fallbackHosts'>;
